import React from "react";

import TypeEmblem from "../TypeEmblem";
import { Description, Text, Title, Wrap } from "./ConfigureIntro.styled";

/**
 * Configure-step intro rendered above the form card: type emblem,
 * "Configure {Type}" title and the type description.
 */
const ConfigureIntro = ({ image, name, title, description }) => (
    <Wrap>
        <TypeEmblem image={image} name={name} size={48} />
        <Text>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
        </Text>
    </Wrap>
);

export default ConfigureIntro;
